import { number, object } from "yup"
import { ID2 } from "../yup.common"

const timeSlotModel = object({
  timeSlot: ID2("Time Slot").required("Please enter a timeslot!"),
  quantity: number()
    .min(0)
    .required("Timeslot booking quantity is required!")
    .label("Quantity")
    .typeError("Please enter valid quantity!"),
  quantityTolerance: number()
    .min(0)
    .max(100)
    .label("Quantity Tolerance")
    .typeError("Please enter valid quantity tolerance"),
  quantityUnit: ID2("Quantity Unit").required(),
})

export default timeSlotModel
